import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import 'leaflet-lasso';
import * as L from 'leaflet';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-map-lasso-control',
    templateUrl: 'lasso.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LassoComponent {
    @Input()
    map: L.Map;

    @Input()
    intersect: boolean = false;

    @Output()
    selected = new EventEmitter();

    lasso;

    active$ = new BehaviorSubject(false);

    toggleLasso() {
        if (this.lasso) {
            this.closeLasso();
            return;
        }

        this.initLasso();
    }

    onFinishedLasso(event) {
        this.selected.emit(event.layers);
        this.closeLasso();
    }

    initLasso() {
        this.lasso = L.lasso(this.map, {
            polygon: { color: 'red', dashOffset: '', fill: false, weight: 1, stroke: true },
            intersect: this.intersect,
        });
        this.active$.next(true);
        this.lasso.enable();
        this.map.on('lasso.finished', this.onFinishedLasso, this);
    }

    closeLasso() {
        if (!this.lasso) return;
        this.lasso = null;
        this.active$.next(false);
        this.map.off('lasso.finished');
    }
}
